import * as React from "react"

const NotificationIcon = (props) => (
  <svg
    width={34}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 29.333c1.558 0 2.833-1.2 2.833-2.666h-5.666c0 1.466 1.274 2.666 2.833 2.666Zm8.5-8v-6.666c0-4.094-2.31-7.52-6.375-8.427v-.907c0-1.106-.95-2-2.125-2-1.176 0-2.125.894-2.125 2v.907c-4.052.907-6.375 4.32-6.375 8.427v6.666L5.667 24v1.333h22.666V24L25.5 21.333Zm-2.834 1.334H11.333v-8c0-3.307 2.14-6 5.667-6 3.527 0 5.666 2.693 5.666 6v8Z"
      fill="#323232"
    />
  </svg>
)

export default NotificationIcon
